var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73236 3.18405C6.95264 3.06052 7.20206 2.9978 7.4553 3.00326C7.70852 3.00871 7.95495 3.08209 8.16966 3.21485L8.17179 3.21617L20.3255 10.7871L20.3274 10.7882C20.5344 10.9163 20.7041 11.0955 20.8212 11.3073C20.9388 11.5196 21 11.7582 21 12.0002C21 12.2422 20.9388 12.4808 20.8212 12.6931C20.7041 12.9049 20.5344 13.0841 20.3274 13.2122L20.3255 13.2133L8.17179 20.7842L8.16966 20.7856C7.95495 20.9183 7.70852 20.9917 7.4553 20.9972C7.20207 21.0026 6.95264 20.9399 6.73236 20.8164C6.51219 20.6929 6.32962 20.5135 6.20171 20.2976C6.07385 20.0818 6.00468 19.8366 6.00012 19.5867L6 19.573V4.42743L6.00012 4.41377C6.00468 4.16377 6.07385 3.91857 6.20171 3.70281C6.32962 3.48695 6.5122 3.30753 6.73236 3.18405Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaFill);
export default __webpack_public_path__ + "static/media/Media-fill.5aaa5f720bef1e510c293f965195322b.svg";
export { ForwardRef as ReactComponent };